var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSumInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M.75 17.25a6.752 6.752 0 0 1 9.4-6.208M3.945 2.781a6.852 6.852 0 0 0 7.642 1.536"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.5,
    d: "M7.5.75A4.125 4.125 0 1 1 7.5 9a4.125 4.125 0 0 1 0-8.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3DC1D3",
    strokeWidth: 1.5,
    d: "M17.25 11.25a6 6 0 1 1 0 12 6 6 0 0 1 0-12zM17.25 20.25v-3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3DC1D3",
    strokeWidth: 1.5,
    d: "M17.25 14.25a.375.375 0 1 0 .002 0h-.002"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumInfo);
export default __webpack_public_path__ + "static/media/sum-info.21f9aa0ca3314579ead34fb12465722b.svg";
export { ForwardRef as ReactComponent };